// extracted by mini-css-extract-plugin
export default {"terminosYCondicionesBody":"TerminosYCondiciones_terminosYCondicionesBody__-Rf0F","condiciones":"TerminosYCondiciones_condiciones__8I7A7"};